import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  prefixUrl = 'admin/';
  constructor(
    private loadingService: LoadingService,
    private alertService: AlertService,
    private authService: AuthService,
    private router: Router,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error) => {
        this.loadingService.idle();

        if (!this.authService.isAuthenticated()) {
          this.prefixUrl = '';
        }

        if ([401, 403].includes(error.status)) {
          this.authService.logout();
        } else if (error.status === 0) {
          if (!navigator.onLine) {
            this.alertService.showCommonAlertMessage('No internet connection. Please check your network.');
          } else {
            this.alertService.showCommonAlertMessage('Network error occurred. Please try again later.');
          }
        } else {
          switch (error?.status) {
            case 400:
              this.alertService.showCommonAlertMessage(error.error.responseMessage || 'Bad Request', error.status);
              break;
            case 404:
              this.alertService.showCommonAlertMessage(error.error.responseMessage || 'Not found', error.status);
              break;
            case 500:
              this.alertService.showCommonAlertMessage(
                error.error.responseMessage || 'Some thing wrong in the server',
                error.status,
              );
              break;
            case 406:
              this.router.navigate([`${this.prefixUrl}error/${error.status}`]);
              break;
            case 503:
              this.router.navigate([`${this.prefixUrl}error/${error.status}`]);
              break;
            default:
              this.alertService.showCommonAlertMessage('An Unknown Error Occurred', error.status);
              break;
          }
        }
        return throwError(() => error);
      }),
    );
  }
}
